export const ASSIGNED_TO_TICKETS_HEADERS = {
  TicketNo: 'Ticket ID',
  Subject: 'Subject',
  Category: 'Category',
  Requestor: 'Created By',
  CreatedOn: 'Created On',
  Status: 'Status',
  OpenSinceDays: 'Open Since',
  StatusLastDate: 'Closed On',
};

export const MY_TICKETS_HEADERS = {
  TicketNo: 'Ticket ID',
  Subject: 'Subject',
  Category: 'Category',
  CreatedOn: 'Created On',
  Status: 'Status',
  OpenSinceDays: 'Open Since',
  StatusLastDate: 'Closed On',
};

export const ALL_TICKETS_HEADERS = {
  TicketNo: 'Ticket ID',
  Subject: 'Subject',
  Category: 'Category',
  Requestor: 'Created By',
  AssignedTo: 'Assigned To',
  CreatedOn: 'Created On',
  Status: 'Status',
  OpenSinceDays: 'Open Since',
  StatusLastDate: 'Closed On',
};

export const ticketTabs = ['assignedToMe', 'allTickets', 'myTickets'];

export const TICKET_STATUS_TYPES = {
  ASSIGNED: 'Assigned',
  IN_PROGRESS: 'In Progress',
  WAITING: 'Waiting....',
  COMPLETED: 'Completed',
  CANCELLED: 'Cancelled',
};

export const TICKET_STATUS_BADGE_STYLES = {
  Assigned: {
    backgroundColor: '#EFF8FF',
    borderColor: '#B2DDFF',
    fontColor: '#175CD3',
  },
  Completed: {
    backgroundColor: '#ECFDF3',
    borderColor: '#ABEFC6',
    fontColor: '#067647',
  },
  'In Progress': {
    backgroundColor: '#FFFAEB',
    borderColor: '#FEDF89',
    fontColor: '#B54708',
  },
  'Waiting....': {
    backgroundColor: '#FFFAEB',
    borderColor: '#FEDF89',
    fontColor: '#B54708',
  },
  Cancelled: {
    backgroundColor: '#FEF3F2',
    borderColor: '#FECDCA',
    fontColor: '#B42318',
  },
};

export const TICKET_TABS = {
  ASSIGNED_TO_ME: 'assignedToMe',
  ALL_TICKETS: 'allTickets',
  MY_TICKETS: 'myTickets',
};

export const TICKET_MAIN_STATUS = {
  OPEN: 'OPEN',
  CLOSED: 'CLOSED',
};
